import React from 'react';
import { LocationPrivacyCheck } from '@members/pg-profile-setup/LocationPrivacy/LocationPrivacyCheck';

export const GlobalComponents: React.FC = () => {
  return (
    <>
      <LocationPrivacyCheck />
    </>
  );
};
